import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";

// ─── Page Layout ───────────────────────────────────────────────────────────────

export const LoginPageWrapper = styled("div")`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  background-color: #f5f5f5;
`;

export const LoginImagePanel = styled("div")`
  flex: 0 0 42%;
  position: sticky;
  top: 0;
  align-self: flex-start;
  height: 100vh;
  overflow: hidden;
  border-radius: 0 16px 16px 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center top;
    display: block;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const LoginFormPanel = styled("div")`
  flex: 1;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #f5f5f5;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
    min-height: 100dvh; /* dynamic viewport height — respeita teclado */
  }
`;

// ─── Top Bar ───────────────────────────────────────────────────────────────────

export const TopBar = styled("div")`
  display: flex;
  justify-content: flex-end;
  padding: 20px 36px 0;
  width: 100%;
  max-width: 500px;
  box-sizing: border-box;

  @media (max-width: 768px) {
    max-width: 100%;
    padding: 16px 20px 0;
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: #f5f5f5;
  }
`;

export const LanguageButton = styled("button")`
  display: flex;
  align-items: center;
  gap: 6px;
  background: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 7px 14px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  color: #444;
  transition: background 0.15s;

  &:hover {
    background: #f0f0f0;
  }

  @media (max-width: 768px) {
    font-size: 12px;
    padding: 6px 12px;
  }
`;

// ─── Form Area ─────────────────────────────────────────────────────────────────

export const LoginFormContent = styled("div")`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 24px 48px 40px;
  max-width: 500px;
  width: 100%;

  @media (max-width: 768px) {
    padding: 24px 24px 48px;
    max-width: 100%;
    justify-content: flex-start; /* top-alinhado no mobile pois teclado empurra conteúdo */
  }
`;

// ─── Logo ──────────────────────────────────────────────────────────────────────

export const LogoWrapper = styled("div")`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 28px;

  @media (max-width: 768px) {
    margin-bottom: 24px;
    margin-top: 8px;
  }
`;

export const LogoImage = styled("img")`
  height: 34px;
  width: auto;

  @media (max-width: 768px) {
    height: 40px; /* ligeiramente maior no mobile */
  }
`;

export const LogoText = styled("span")`
  font-size: 20px;
  font-weight: 800;
  color: #00b6bc;
  letter-spacing: 2px;
  text-transform: uppercase;
`;

export const LogoTextPer = styled("span")`
  color: #00b6bc;
`;

export const LogoTextTalks = styled("span")`
  color: #007d82;
`;

// ─── Welcome Text ──────────────────────────────────────────────────────────────

export const WelcomeTitle = styled("h1")`
  font-size: 34px;
  font-weight: 800;
  color: #1a1a1a;
  margin: 0 0 8px 0;
  line-height: 1.15;

  @media (max-width: 768px) {
    font-size: 28px;
  }

  @media (max-width: 380px) {
    font-size: 24px;
  }
`;

export const WelcomeSubtitle = styled("p")`
  font-size: 14px;
  color: #999;
  margin: 0 0 32px 0;

  @media (max-width: 768px) {
    margin: 0 0 24px 0;
  }
`;

// ─── Input Fields ──────────────────────────────────────────────────────────────

export const InputGroup = styled("div")`
  margin-bottom: 18px;

  @media (max-width: 768px) {
    margin-bottom: 14px;
  }
`;

export const InputGroupLabel = styled("label")`
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #444;
  margin-bottom: 6px;
`;

export const InputRequired = styled("span")`
  color: #e53935;
  margin-left: 2px;
`;

export const InputWrapper = styled("div")`
  display: flex;
  align-items: center;
  border: 1.5px solid #e8e8e8;
  border-radius: 10px;
  background: #ffffff;
  padding: 0 14px;
  transition: border-color 0.2s;

  &:focus-within {
    border-color: #00b6bc;
    box-shadow: 0 0 0 3px rgba(0, 182, 188, 0.1);
  }

  @media (max-width: 768px) {
    border-radius: 12px; /* bordas mais arredondadas no mobile como no Figma */
  }
`;

export const InputIconWrapper = styled("span")`
  display: flex;
  align-items: center;
  color: #c0c0c0;
  margin-right: 10px;
  flex-shrink: 0;
`;

export const StyledInput = styled("input")`
  flex: 1;
  border: none;
  outline: none;
  padding: 14px 0;
  font-size: 14px;
  color: #222;
  background: transparent;
  min-width: 0; /* evita overflow em telas pequenas */

  /* impede zoom automático no iOS ao focar */
  @media (max-width: 768px) {
    font-size: 16px;
    padding: 14px 0;
  }

  &::placeholder {
    color: #c0c0c0;
  }
`;

export const PasswordToggleBtn = styled(IconButton)`
  padding: 4px !important;
  color: #c0c0c0 !important;
  margin-left: 4px;

  &:hover {
    color: #00b6bc !important;
    background: transparent !important;
  }

  /* área de toque maior no mobile */
  @media (max-width: 768px) {
    padding: 8px !important;
  }
`;

// ─── Buttons & Links ───────────────────────────────────────────────────────────

export const EnterButton = styled("button")`
  width: 100%;
  padding: 15px;
  background-color: #00b6bc;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 8px;
  letter-spacing: 0.3px;
  transition: background 0.2s, transform 0.1s;

  &:hover:not(:disabled) {
    background-color: #009fa5;
    transform: translateY(-1px);
  }

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #a8dfe1;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    border-radius: 12px;
    padding: 16px;
    font-size: 16px;
    min-height: 52px; /* área de toque confortável */
    -webkit-tap-highlight-color: transparent;
  }
`;

export const ForgotLink = styled("a")`
  display: block;
  text-align: center;
  margin-top: 18px;
  font-size: 14px;
  font-weight: 500;
  color: #00b6bc;
  cursor: pointer;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: #009fa5;
  }

  @media (max-width: 768px) {
    margin-top: 20px;
    padding: 8px 0; /* área de toque maior */
    font-size: 15px;
    -webkit-tap-highlight-color: transparent;
  }
`;

export const BackLink = styled("a")`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #999;
  cursor: pointer;
  text-decoration: none;
  margin-bottom: 20px;

  &:hover {
    color: #00b6bc;
  }

  @media (max-width: 768px) {
    padding: 8px 0;
    font-size: 14px;
    -webkit-tap-highlight-color: transparent;
  }
`;

// ─── Footer / Credit ───────────────────────────────────────────────────────────

export const DeveloperCredit = styled("div")`
  text-align: center;
  padding: 16px;
  font-size: 11px;
  color: #ccc;
  margin-top: auto;
`;

export const LoginA = styled("a")`
  color: #00b6bc;
  text-decoration: none;
  font-size: 11px;

  &:hover {
    text-decoration: underline;
  }
`;

// ─── Kept for backward compat ──────────────────────────────────────────────────

export const ImgSgv = styled("img")``;